export default "__VITE_ASSET__bf009175__"